import { get } from './shared';

export function checkBrand(brand: string) {
  const endpoint = `publisher/brands/check/${brand}`;
  return get(endpoint);
}
